import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

// Legacy /stadium-lighting/:slug → /stadium-sports-lighting/:slug
export const Route = createFileRoute("/stadium-lighting/$slug")({
  beforeLoad: ({ params }) => legacyRedirect(`/stadium-sports-lighting/${params.slug}`),
});
